import { PenTool, Printer, Hammer, Quote } from "lucide-react";
import { ABOUT_TEXT, IMAGES } from "../data/siteData";
import { Reveal } from "./Reveal";

const FEATURES = [
    { icon: PenTool, title: "Progettazione", text: "Ogni lavoro nasce da un'idea disegnata su misura, mai da un modello preconfezionato." },
    { icon: Printer, title: "Produzione", text: "Stampa e lavorazione seguite direttamente nel nostro laboratorio, con controllo su ogni dettaglio." },
    { icon: Hammer, title: "Posa & Montaggio", text: "Anni di esperienza nell'allestimento e nel montaggio d'interni, per un risultato chiavi in mano." },
];

export const About = () => {
    return (
        <section id="chi-siamo" data-testid="about-section" className="py-16 sm:py-24 lg:py-32 bg-white border-y border-zinc-200">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
                    <Reveal className="lg:col-span-5 order-2 lg:order-1">
                        <div className="relative">
                            <div className="absolute -top-4 -left-4 w-full h-full border border-[#FF0066]" />
                            <img
                                src={IMAGES.about}
                                alt="Il laboratorio creativo di Studio Arti Grafiche"
                                data-testid="about-image"
                                className="relative w-full aspect-[4/5] object-cover"
                            />
                        </div>
                    </Reveal>
                    <div className="lg:col-span-7 order-1 lg:order-2">
                        <Reveal>
                            <p className="font-mono-label text-xs text-[#FF0066] mb-4">Chi Siamo</p>
                            <h2 data-testid="about-title" className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-tight text-[#0E0E10]">
                                La nostra storia: tra arte grafica e stampa
                            </h2>
                        </Reveal>
                        <Reveal delay={0.12}>
                            <div className="mt-8 relative pl-6 border-l-2 border-[#FFCC00]">
                                <Quote size={20} className="absolute -left-3 top-0 bg-white text-[#FF0066]" />
                                <p data-testid="about-narrative" className="font-serif-accent italic text-lg sm:text-xl leading-relaxed text-zinc-700">
                                    {ABOUT_TEXT}
                                </p>
                            </div>
                        </Reveal>
                        <div className="mt-10 grid sm:grid-cols-3 gap-6">
                            {FEATURES.map((f, i) => (
                                <Reveal key={f.title} delay={0.16 + i * 0.1}>
                                    <div data-testid={`about-feature-${f.title.toLowerCase().replace(/\s|&/g, "-")}`} className="h-full border border-zinc-200 bg-[#FAF8F5] p-5 hover:border-[#0E0E10] transition-colors duration-300">
                                        <f.icon size={22} className="text-[#FF0066]" />
                                        <h3 className="mt-3 font-heading font-bold text-base">{f.title}</h3>
                                        <p className="mt-2 text-sm leading-relaxed text-zinc-600">{f.text}</p>
                                    </div>
                                </Reveal>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
